import WarningIcon from '@cartwhl/ui/icons/WarningIcon';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

import { animationGenerationStore } from 'stores';

export default function FlaggedVideoModal({ close }: { close: () => void }) {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      close();
    }
  };
  const handleIUnderstand = () => {
    close();
    animationGenerationStore.handleVideoUploadFailed();
  };
  return (
    <Modal
      open={true}
      onOpenChange={handleOpenChange}
      closeOnClickOutside={false}
      maxWidth={370}
    >
      <h1 className="font-display bg-red/10 dark:bg-red/20 text-red mb-4 flex items-center gap-2 rounded-lg p-2 text-2xl text-[16px] font-medium">
        <WarningIcon />
        Your video has been blocked
      </h1>
      <p className="text-gray-60 dark:text-gray-30 text-[14px]/[18px]">
        Your video upload was blocked because it may violate our community
        guidelines. <br />
        <br />
        If you feel you're seeing this message in error, please try uploading
        the video again. For more details on video upload guidelines, please see
        our{' '}
        <a
          href="https://docs.getcartwheel.com/docs/creating-motion/video-to-motion"
          target="_blank"
          className="text-blue underline"
        >
          video documentation
        </a>
        . <br />
        <br />
        If you continue to encounter problems please{' '}
        <a
          href="mailto:support@getcartwheel.com?subject=Help%20with%20blocked%20video"
          className="text-blue underline"
          target="_blank"
        >
          contact support
        </a>
        .
      </p>
      <div className="mt-10 flex justify-end">
        <Button variant="primary" onClick={handleIUnderstand}>
          I understand
        </Button>
      </div>
    </Modal>
  );
}
